import React from "react";

export default function SubmitButton({ 
  isSubmitting, 
  disabled, 
  submittingText = "Procesando...", 
  text = "Guardar"
}) {
  return (
    <button type="submit" className="btn btn-primary" disabled={disabled || isSubmitting}>
      {isSubmitting ? (
        <div className="d-flex align-items-center" style={{ gap: "5px" }}>
          <div className="spinner-border spinner-border-sm" role="status" />
          {submittingText}
        </div>
      ) : (
        text
      )}
    </button>
  );
}
